import { Navigation } from 'components'
import Text from 'components/priority/Text/Text'

export const Analytics = () => {
  return (
    <>
      <Navigation type="admin" />
      <Text margin="32px 0 0 0">Analytics</Text>
    </>
  )
}

export default Analytics
